'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.year;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/year.js
// module id = 222
// module chunks = 0